import { InjectionKey } from 'vue'
import { IUploadService } from './IUploadService'
import { IProviderIconService } from './IProviderIconService'
import { ISnapshotService } from './ISnapshotService'
import { ISearchService } from './ISearchService'
import { IProjectService } from './IProjectService'
import { IGlobalFilterService } from './IGlobalFilterService'
import { ICustomMetricService } from './ICustomMetricService'
import { IArtifactService } from './IArtifactService'
import { IDashboardService } from './IDashboardService'
import { IColorConverterService } from './IColorConverterService'
import ChartService from './IChartService'
import RappidContext from '@/pages/explorer/rappid/rappid-context'
import { IGlobalFiltersToolboxService } from './IGlobalFiltersToolboxService'
import { IRouteParamValidator } from './IRouteParamValidator'
import { IRouteStoreSync } from './IRouteStoreSync'

export const ServiceKeys = {
  upload: Symbol('upload') as InjectionKey<IUploadService>,
  snapshot: Symbol('snapshot') as InjectionKey<ISnapshotService>,
  search: Symbol('search') as InjectionKey<ISearchService>,
  project: Symbol('project') as InjectionKey<IProjectService>,
  artifact: Symbol('artifact') as InjectionKey<IArtifactService>,
  routeParamValidator: Symbol('routeParamValidator') as InjectionKey<IRouteParamValidator>,
  routeStoreSync: Symbol('routeStoreSync') as InjectionKey<IRouteStoreSync>,
  providerIcon: Symbol('providerIcon') as InjectionKey<IProviderIconService>,
  globalFilter: Symbol('globalFilter') as InjectionKey<IGlobalFilterService>,
  customMetrics: Symbol('customMetrics') as InjectionKey<ICustomMetricService>,
  dashboard: Symbol('dashboard') as InjectionKey<IDashboardService>,
  colorConverter: Symbol('colorConverter') as InjectionKey<IColorConverterService>,
  chart: Symbol('chart') as InjectionKey<ChartService>,
  rappidContext: Symbol('rappidContext') as InjectionKey<RappidContext>,
  globalFiltersToolbox: Symbol(
    'globalFiltersToolbox',
  ) as InjectionKey<IGlobalFiltersToolboxService>,
}
